import { render, staticRenderFns } from "./BlackAwardPrize.vue?vue&type=template&id=17ef1c87&scoped=true&"
import script from "./BlackAwardPrize.vue?vue&type=script&lang=js&"
export * from "./BlackAwardPrize.vue?vue&type=script&lang=js&"
import style0 from "./BlackAwardPrize.vue?vue&type=style&index=0&id=17ef1c87&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ef1c87",
  null
  
)

export default component.exports